import React from 'react';
import { Route } from 'react-router';
import { withProps } from 'recompose';
import camelize from 'camelize';
import PromotionTnCContainer from '../Promotion/PromotionTnCContainer';
import { fetchPromotionTnC } from '../Common/Providers/PromotionGroupApi';

const fetchPromotionTnCComponent = (location, callback) => {
  fetchPromotionTnC(location.params.splat)
    .done((response) => {
      callback(null, withProps(camelize({ ...response.data }))(PromotionTnCContainer));
    })
    .fail(() => {
      window.location = '/invalid-promotions';
    });
};

const PromotionTnCRoute = (
  <Route label="Prepaid"
    helmet={{
      title: 'Terms and Conditions',
      metaDescription: 'The Right Deals and Discounts',
    }}
    path="*" // slug
    getComponent={fetchPromotionTnCComponent}
  >
  </Route>
);

export default PromotionTnCRoute;



// WEBPACK FOOTER //
// ./src/Routes/PromotionTnC.js